import axios from 'axios';
import React, { useState, useEffect } from 'react';

export default function ShopifyConnect({ toggleModal, session }) {
  const [shopUrl, setShopUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  // console.log("SHOP URL", shopUrl)
  const handleConnect = async () => {
    console.log('[ShopifyConnect] Connect button clicked');
    if (!shopUrl.trim()) {
      setError('Please enter your shop URL');
      return;
    }
    console.log('[ShopifyConnect] Shop URL entered:', shopUrl);
    // Validate shop URL format
    const shopUrlPattern = /^[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com$/;
    if (!shopUrlPattern.test(shopUrl.trim())) {
      setError('Please enter a valid Shopify URL (e.g., your-store.myshopify.com)');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Clean the shop URL (remove protocol if present)
      const cleanShop = shopUrl.trim().replace(/^https?:\/\//, '').replace(/\/$/, '');
      console.log('[ShopifyConnect] Clean shop URL:', cleanShop);
      
      // First, try to verify the API endpoint is accessible
      const authUrl = `/api/shopify-authenticate?shop=${encodeURIComponent(cleanShop)}&returnTo=InstallationWizard`;
      console.log('[ShopifyConnect] Redirecting to:', authUrl);
      
      // Pass returnTo so callback knows to redirect back to Installation Wizard
      window.location.href = authUrl;
      
    } catch (err) {
      console.error('[ShopifyConnect] Error connecting to Shopify:', err);
      setError(`Failed to initiate Shopify connection: ${err.message || 'Please try again.'}`);
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConnect();
    }
  };
  
  // Remove auto-refresh as it can cause issues
  // useEffect(() => {
  //   if (!sessionStorage.getItem('shopifyConnectRefreshed')) {
  //     sessionStorage.setItem('shopifyConnectRefreshed', 'true');
  //     window.location.reload();
  //   }
  // }, []);

  return (
    <>
      <div className="bg-gray-800 bg-opacity-50 fixed flex inset-0 items-center justify-center z-50">
        <div className="relative bg-white max-w-4xl p-6 rounded-lg shadow-lg w-full">
          {/* Close Button */}
          <button
            onClick={() => toggleModal("close")}
            className="absolute z-10 top-4 right-4 rounded-full shadow-lg bg-white p-2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-7 h-7"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-black">
              Connect to Shopify
            </h2>
          </div>
          
          <div className="mb-6">
            <p className="text-gray-600 mb-4">
              Enter your Shopify store URL to connect your sales channel.
            </p>
            
            <div className="mb-4">
              <label htmlFor="shopUrl" className="block text-sm font-medium text-gray-700 mb-2">
                Shop URL
              </label>
              <input
                type="text"
                id="shopUrl"
                value={shopUrl}
                onChange={(e) => setShopUrl(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter your shop URL"
                className="w-full px-3 py-2 text-gray-950 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled={isLoading}
              />
            </div>
            
            {error && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
                <p className="text-red-600 text-sm">{error}</p>
              </div>
            )}
            
            <div className="text-sm text-gray-500 mb-4">
              <p>Example: your-store.myshopify.com</p>
            </div>
          </div>
          
          <div className="flex justify-end">
            <button
              onClick={handleConnect}
              disabled={isLoading}
              className={`px-4 py-2 rounded-md text-white ${
                isLoading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-[#284F9E] hover:bg-blue-700'
              }`}
            >
              {isLoading ? (
                <div className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Connecting...
                </div>
              ) : (
                'Connect'
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
} 